import { ArrowRight } from 'lucide-react';
import Image from 'next/image';
import Link from 'next/link';

// Это простой презентационный компонент для одного баннера.
// Он серверный, поэтому очень быстрый.
export function BannerNew() {
  return (
    <Link
      href="#"
      className="group bg-slate-800/50 hover:bg-slate-800/80 border border-slate-700/50 rounded-lg p-3 transition-all duration-300 w-full h-full flex flex-col"
    >
      {/* Контейнер для изображения */}
      <div className="relative aspect-video rounded-md overflow-hidden mb-3">
        <Image
          src="/banner/Our Tomsk.jpeg"
          alt="Рекламный баннер"
          fill
          className="object-cover transition-transform duration-300 group-hover:scale-105"
        />
      </div>

      {/* ✅ ИСПРАВЛЕНИЕ 2: Создаем контейнер для текста, который будет "расти". */}
      {/* flex-grow заставит этот блок занять всё оставшееся свободное пространство. */}
      <div className="flex flex-col flex-grow">
        <h4 className="font-semibold text-white">Заголовок баннера</h4>
        <p className="text-sm text-slate-400 mt-1">
          Краткое описание вашего предложения или рекламы.
        </p>

        {/* ✅ ИСПРАВЛЕНИЕ 3: mt-auto прижмет ссылку "Подробнее" к низу. */}
        <div className="text-sky-400 text-sm font-semibold mt-auto pt-2 flex items-center gap-1">
          Подробнее
          <ArrowRight className="w-4 h-4 transition-transform duration-300 group-hover:translate-x-1" />
        </div>
      </div>
    </Link>
  );
}
